import { apply, put } from 'redux-saga/effects';
import {
  loadAreasSucceeded,
  loadAreasFailed,
} from '../reducers/filter.reducers';

export default function* loadAreas(locationApi, { payload }) {
  const response = yield apply(locationApi, locationApi.loadAreas, [payload]);
  if (response.errorCode || response.message) {
    yield put(loadAreasFailed());
    return;
  }

  yield put(loadAreasSucceeded({
    areas: response,
  }));
}
